import {useCallback} from "react";
import {
    DateField,
    SelectField,
    InputField,
    SelectCustomerAll
} from "~/components/Forms";
import {strToTime} from "~/utils";
import {useCan} from "../../../../hooks";

function ToDoSearchBar({status, filter, onSearchChange, onChange})
{
    const handleKeywordChange = (e) => {
        if (!onSearchChange) return;
        const newFilter = {
            ...filter,
            keyword: e.target.value,
            page: 1,
        };
        onSearchChange(newFilter);
    }

    return (
        <div className="search-bar">
            <div className="container">
                <form className="form" autoComplete="off">
                    <InputField defaultValue={filter.keyword} placeholder="Tên miền" onChange={handleKeywordChange}/>
                </form>
            </div>
        </div>
    )
}

export default ToDoSearchBar;